import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=33ce5c19&scoped=true"
import script from "./editForm.vue?vue&type=script&lang=js"
export * from "./editForm.vue?vue&type=script&lang=js"
import style0 from "./editForm.vue?vue&type=style&index=0&id=33ce5c19&prod&lang=scss&scoped=true"
import style1 from "./editForm.vue?vue&type=style&index=1&id=33ce5c19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce5c19",
  null
  
)

export default component.exports